module.exports = __webpack_public_path__ + "static/media/12-RPEX9.50e4372a.jpg";